export class CreateKeyValueRequest {
    public descripcion?:string | null;
    public observaciones?:string | null;
    constructor(
      descripcion: string | null = null,
      observaciones: string | null = null,
    ) {
      this.descripcion = descripcion;
      this.observaciones = observaciones;
    }
}
